<!--
 * @Author: Hyman Choi
 * @Date: 2021-02-03 11:44:57
 * @LastEditTime: 2021-10-28 10:56:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\quizManagement\quizDetail\index.vue
-->
<template>
	<div class="app-container">
		<el-button @click="goback" type="primary" size="small" style="margin-bottom: 20px;">返回</el-button>
		<el-tabs v-model="activeIndex" type="border-card" @tab-click="handleTabChange()">
			<el-tab-pane v-for="item in tabList" :key="item.name" :label="item.label" :name="item.name">
				<keep-alive>
					<component v-bind:is="item.name" :problemId="problemId"></component>
				</keep-alive>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import QuizDetail from "@/components/QuizManagement/QuizDetail.vue";
	import AnswerList from "@/components/QuizManagement/AnswerList.vue";
	import ExpertList from "@/components/QuizManagement/ExpertList.vue";
  import {isVaild} from "@/utils/validate";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

  export default {
		components: {
			QuizDetail,
			AnswerList,
			ExpertList,
		},
		created() {
			this.problemId = this.$route.query.problemId
      let activeName = getNavigationItemObj(this.tabKey).activeIndex
      if(isVaild(activeName)){
        this.activeIndex = activeName
      }
		},
		data() {
			return {
        //记录当前页面所处tab，跳转返回可以回到改tab，不会到第一个
        tabKey:"quizDetailTab",
				problemId: 0,
				activeIndex: "QuizDetail", // 当前索引
				loading: false, // 加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				problem: {},
				answerList: [],
				tabList: [{
						name: "QuizDetail",
						label: "问题详情",
					},
					{
						name: "AnswerList",
						label: "答案列表",
					},
					{
						name: "expertList",
						label: "邀请专家列表",
					},
				],
			};
		},
		methods: {
			goback() {
				this.$router.go(-1)
			},
      handleTabChange(){
        setNavigationItemWithObj(this.tabKey,{activeIndex:this.activeIndex})
      }
		},
	};
</script>

<style scoped lang="scss"></style>
